import { Flex } from "@chakra-ui/layout";
import styled from "@emotion/styled";
import Gray100Skeleton from "./Gray100Skeleton";
import Gray50Skeleton from "./Gray50Skeleton";

function Description() {
  return (
    <div>
      <Gray50Skeleton h="12px" w="34px" />
      <Gray50Skeleton h="20px" w="86px" mt="4px" />
    </div>
  );
}

function GrayDetailItem() {
  return (
    <GrayDetailItemRoot>
      <Gray100Skeleton h="14px" />
      <Gray100Skeleton h="14px" mt="12px" />
      <Gray100Skeleton h="14px" mt="12px" />
      <Gray100Skeleton h="14px" mt="12px" />
    </GrayDetailItemRoot>
  );
}

function WhiteDetailItem() {
  return (
    <WhiteDetailItemRoot>
      <Gray50Skeleton h="14px" />
      <Gray50Skeleton h="14px" mt="12px" />
      <Gray50Skeleton h="14px" mt="12px" />
      <Gray50Skeleton h="14px" mt="12px" />
    </WhiteDetailItemRoot>
  );
}

function DetailSkeleton() {
  return (
    <DetailSkeletonRoot>
      <Flex flexDirection="column" p="0 20px" width="100%">
        <Gray50Skeleton h="16px" w="68px" />
        <Gray50Skeleton h="22px" w="180px" mt="14px" />
        <Flex mt="46px">
          <Description />
          <div style={{ marginLeft: "40px" }} />
          <Description />
        </Flex>
        <Gray50Skeleton h="46px" mt="16px" />
        <Gray50Skeleton h="16px" w="68px" mt="54px" />
      </Flex>
      <div style={{ marginTop: "8px" }} />
      <GrayDetailItem />
      <WhiteDetailItem />
      <GrayDetailItem />
      <WhiteDetailItem />
    </DetailSkeletonRoot>
  );
}

const DetailSkeletonRoot = styled.div`
  padding: 36px 0 34px;
  width: 100%;
`;

const GrayDetailItemRoot = styled.div`
  padding: 54px 20px;
  background: var(--gray50);
`;

const WhiteDetailItemRoot = styled.div`
  padding: 54px 20px;
  background: var(--white);
`;

export default DetailSkeleton;
